import tv, { SchemaType } from "typed-object-validator";

const API_KEY = "AIzaSyD1pkSJHRMxltsPlvgbjA4uloXpc3u4Xe4";

export const AddressSchema = tv.object({
    streetNumber: tv.string().optional().nullable(), // street_number
    street: tv.string().optional().nullable(), // route
    location: tv.string().optional().nullable(), // administrative_area_level_2
    city: tv.string().optional().nullable(), // locality
    province: tv.string().optional().nullable(), // administrative_area_level_1
    country: tv.string().optional().nullable(), // country
    postalCode: tv.string().optional().nullable(), // postal_code
    full: tv.string(), // formatted_address
    lat: tv.number().float(),
    long: tv.number().float(),
});
export type Address = SchemaType<typeof AddressSchema>;

export async function geoCode(query: string, requireStreet: boolean): Promise<Address[]> {
    let resp = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(query)}&key=${API_KEY}&language=nl&region=be`
    );
    if (!resp.ok) {
        console.warn("google not ok response", resp.status);
        return [];
    }
    let res = await resp.json();

    let addresses: Address[] = [];
    for (let i = 0; i < res.results.length; i++) {
        let e = res.results[i];
        let c: any[] = e.address_components;
        let a: Address = {
            full: e.formatted_address,
            lat: e.geometry.location.lat,
            long: e.geometry.location.lng,
            streetNumber: c.find((e) => e.types.includes("street_number"))?.long_name,
            street: c.find((e) => e.types.includes("route"))?.long_name,
            location: c.find((e) => e.types.includes("administrative_area_level_2"))?.long_name,
            city: c.find((e) => e.types.includes("locality"))?.long_name,
            province: c.find((e) => e.types.includes("administrative_area_level_1"))?.long_name,
            country: c.find((e) => e.types.includes("country"))?.long_name,
            postalCode: c.find((e) => e.types.includes("postal_code"))?.long_name,
        };
        if (requireStreet && (!a.streetNumber || !a.street)) continue;
        addresses.push(a);
    }

    return addresses;
}

/*{
   "results" : [
      {
         "address_components" : [
            {
               "long_name" : "4",
               "short_name" : "4",
               "types" : [ "street_number" ]
            },
            {
               "long_name" : "Het Hoeksken",
               "short_name" : "Het Hoeksken",
               "types" : [ "route" ]
            },
            {
               "long_name" : "Overslag",
               "short_name" : "Overslag",
               "types" : [ "locality", "political" ]
            },
            {
               "long_name" : "Terneuzen",
               "short_name" : "Terneuzen",
               "types" : [ "administrative_area_level_2", "political" ]
            },
            {
               "long_name" : "Zeeland",
               "short_name" : "ZE",
               "types" : [ "administrative_area_level_1", "political" ]
            },
            {
               "long_name" : "Nederland",
               "short_name" : "NL",
               "types" : [ "country", "political" ]
            },
            {
               "long_name" : "4575 NG",
               "short_name" : "4575 NG",
               "types" : [ "postal_code" ]
            }
         ],
         "formatted_address" : "Het Hoeksken 4, 4575 NG Overslag, Nederland",
         "geometry" : {
            "location" : {
               "lat" : 51.2023723,
               "lng" : 3.8912302
            },
            "location_type" : "ROOFTOP",
            "viewport" : {
               "northeast" : {
                  "lat" : 51.2037212802915,
                  "lng" : 3.892579180291502
               },
               "southwest" : {
                  "lat" : 51.2010233197085,
                  "lng" : 3.889881219708498
               }
            }
         },
         "place_id" : "ChIJrWm0YYmBw0cRJ0bkKYT09oI",
         "plus_code" : {
            "compound_code" : "6V2R+WF Overslag, Nederland",
            "global_code" : "9F356V2R+WF"
         },
         "types" : [ "street_address" ]
      }
   ],
   "status" : "OK"
}
*/
